<template>
  <div class="login-box">
    <div class="login-bg"></div>
    <div class="login-content">
      <div class="login-close" @click="closeLogin"></div>
      <div class="login-first" v-if="firstShow">
        <div class="login-title">登录进入网上展馆</div>
        <div class="phone-box">
          <input
            type="number"
            maxlength="11"
            v-model="phone"
            class="phone-num"
            placeholder="输入手机号码"
          />
        </div>
        <div class="verify-box">
          <input
            type="text"
            class="verify-num"
            maxlength="4"
            v-model="verifyCode"
            placeholder="输入验证码"
          />
          <span class="verify-code"  >
            <img
              :src="imgR" alt=""
            />
          </span>
          <span
            class="refresh"
            @click="refresh"
            :class="{ active: hasRefrsh }"
          ></span>
        </div>
        <div
          class="getVerifyCode"
          :class="{ active: canGetSms }"
          @click="getSms"
        >
          获取手机验证码
        </div>
      </div>

      <div class="login-second" v-if="!firstShow">
        <div class="login-title">输入手机验证码</div>
        <div class="login-subtitle">已发送到手机号：{{ hidePhone(phone) }}</div>
        <div class="sms-verify-box">
          <div class="code-all">
            <div
              class="code-input-main-item"
              v-for="(item, index) in codeList"
              :key="index"
            >
              <input
                type="number"
                maxlength="1"
                max="9"
                min="0"
                class="code-item"
                @keydown="clearInput"
                @keyup="goVertify"
              />
            </div>
          </div>

          <div class="error-msg" v-if="errmsg">{{ errmsg }}</div>
        </div>
        <div
          class="again-btn"
          :class="{ disable: !isShowVertifyCode }"
          @click="reSend"
        >
          重新发送<span v-if="!isShowVertifyCode">({{ timersecond }} s)</span>
        </div>
        <div class="support-info">仅支持中国大陆手机号注册</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getImageUrl, getSmsCode, smsLogin, ssoRequest } from "@/api/message.js";

export default {
  data() {
    return {
      phone: "",
      verifyCode: "",
      firstShow: true,
      hasRefrsh: false,
      codeList: [],
      timersecond: 60,
      imgR: "",
      inputVertifyCode: [],
      isShowVertifyCode: true,
      timerInter: "",
      errmsg: "",
    };
  },
  computed: {
    canGetSms() {
      if (this.verifyPhone(this.phone) && this.verifyCode.length == 4) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    refresh() {
      this.hasRefrsh = true;
      this.getImageCode()
    },
    getImageCode() {
      getImageUrl().then(res => {
        let blob = new Blob([res], {
          type: "image/png",
        });
        let url = window.URL.createObjectURL(blob);
        this.hasRefrsh = false;
        this.imgR = url
        // setTimeout(() => {
        //   window.URL.revokeObjectURL(url);
        // }, 3000);

      })
    },
    verifyPhone(phone) {
      if (phone && /^1[3-9]\d{9}$/.test(phone)) {
        return true;
      } else {
        return false;
      }
    },
    getSms() {
      if (this.canGetSms) {
        this.getVerifyCodeFun();
      } else {
        this.$message.error("请填写正确的信息");
      }
    },
    getVerifyCodeFun() {
     
      const that = this;
         
      getSmsCode({
        mobile: this.phone,
        captcha_type: "2",
        pic_code: this.verifyCode,
        send_type: 4,
      }).then(data => {
       
        that.firstShow = false;
        that.setTimersecond();
        setTimeout(() => {
          let vertifyInputArray = document.querySelectorAll(".code-item");
          vertifyInputArray[0].focus();
        }, 1000);


      }).catch(err => {
            // that.getImageCode()
      })
    },
    setTimersecond() {
      this.timersecond = 60;
      var that = this;
      this.isShowVertifyCode = false;
      this.timerInter = setInterval(() => {
        this.timersecond--;
        if (this.timersecond === 0) {
          clearInterval(that.timerInter);
          this.isShowVertifyCode = true;
        }
      }, 1000);
    },
    reSend() {
      if (this.isShowVertifyCode) {
      
        this.getVerifyCodeFun();
      }
    },
    hidePhone(phone) {
      if (phone) {
        return phone.substring(0, 3) + "****" + phone.substring(7, 11);
      }
    },

    clearInput(event) {
      if (event.srcElement.value.toString().length >= 1) {
        event.srcElement.value = "";
      }
    },
    goVertify(event) {
      let vertifyInputArray = document.getElementsByClassName("code-item");
      this.errmsg = ""
      for (let n1 = 0; n1 < vertifyInputArray.length; n1++) {
        if (event.srcElement === vertifyInputArray[n1]) {
          this.inputVertifyCode[n1] = vertifyInputArray[n1].value;

          if (n1 === vertifyInputArray.length - 1) {
            this.doGovertify();
          } else {
            if (vertifyInputArray[n1].value !== "") {
              vertifyInputArray[n1 + 1].focus();
            }
          }
        }
      }
    },
    doGovertify() {
      const smscode = this.inputVertifyCode.join("");
      const that = this;
      smsLogin({
        mobile: this.phone,
        sms_code: smscode,
        rem_login: "1"
      }).then(res => {
        const { data } = res;
        that.$emit("closeLogin");
        localStorage.setItem("userId", data.ticket);
        ssoRequest(data.sso[4]);
      })
    },
    closeLogin(){
      this.$emit("closeLogin")
    }
  },
  mounted() {
    this.codeList = new Array(6).fill("");
    this.inputVertifyCode = new Array(6).fill("");
    this.getImageCode()
  },
  created() {},
};
</script>
<style lang="scss" scope>
.login-box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  .login-bg {
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
    position: absolute;
    top: 0;
    left: 0;
  }
  .login-content {
    width: 600px;
    height: 447px;
    background-color: #f5f5f5;
    border-radius: 16px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -223.5px;
    margin-left: -300px;
    .login-close {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 15px;
      right: 15px;
      background-image: url("../assets/img/login-close.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      z-index: 200;
    }
    .login-first {
      width: 100%;
      height: 100%;
      padding-top: 55px;
      .login-title {
        color: #000000;
        font-size: 32px;
        text-align: center;
        font-weight: bold;
      }
      .phone-box {
        width: 480px;
        height: 62px;
        margin: 30px auto;
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none !important;
          margin: 0;
        }
        .phone-num {
          width: 100%;
          height: 100%;
          background-color: #ffffff;
          border-radius: 32px;
          border: none;
          outline: none;
          font-size: 16px;
          color: #333333;
          padding-left: 30px;
          &::placeholder {
            color: #9d9d9d;
          }
        }
      }
      .verify-box {
        width: 480px;
        height: 62px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .verify-num {
          width: 258px;
          height: 62px;
          background-color: #ffffff;
          border-radius:32px;
          border: none;
          outline: none;
          font-size: 16px;
          color: #333333;
          padding-left: 30px;
          &::placeholder {
            color: #9d9d9d;
          }
        }
        .verify-code {
          margin-left: 18px;
          margin-right: 18px;
          // width: 128px;
          height: 60px;
          background-color: #c7c7c7;
          font-size: 0;
          color: #ffffff;
          text-align: center;
          line-height: 60px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .refresh {
          width: 36px;
          height: 40px;
          background: url("../assets/img/login-refresh.png") no-repeat center;
          background-size: contain;
          &.active {
            animation: refresh 1s;
          }
        }
      }
      .getVerifyCode {
        width: 356px;
        height: 62px;
        background-color: #990000;
        font-size: 16px;
        line-height: 62px;
        text-align: center;
        color: #ffffff;
        border-radius: 50px;
        margin: 0 auto;
        margin-top: 42px;
        cursor: pointer;
        &.active {
          background-color: #990000;
          cursor: pointer;
        }
      }
    }
    .login-second {
      width: 100%;
      height: 100%;
      padding-top: 55px;
      .login-title {
        color: #000000;
        font-size: 24px;
        text-align: center;
        font-weight: bold;
      }
      .login-subtitle {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #9F9F9F;
        text-align: center;
        margin: 35px auto;
      }
      .sms-verify-box {
        margin: 40px auto;

        .code-all {
          display: flex;
          flex-direction: row;
          justify-content: center;
          position: relative;
          .code-input-main-item {
            width: 50px;
            height: 73px;
            margin-right: 5px;
            border-bottom: solid #9F0000 3px;
            text-align: center;
            font-size: 24px;
            color: #333333;
            &:last-child {
              margin-right: 0;
            }
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
              -webkit-appearance: none !important;
              margin: 0;
            }
            .code-item {
              width: 50px;
              height: 60px;
              background-color: #ffffff;
              border-radius: 10px;
              text-align: center;
              line-height: 60px;
              text-align: center;
              font-size: 24px;
              color: #333333;
            }
          }
        }

        .error-msg {
          color: #ee1917;
          font-size: 14px;
          margin-top: 10px;
        }
      }
      .again-btn {
        width: 240px;
        height: 48px;
        background-color: #9F0000;
        color: #ffffff;
        margin: 0 auto;
        border-radius: 24px;
        line-height: 48px;
        font-size: 16px;
        margin-bottom: 28px;
        cursor: pointer;
        &.disabled {
          background-color: #9d9d9d;
          cursor: default;
        }
      }
      .support-info {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #9F9F9F;
        text-align: center;
      }
    }
  }
}
@keyframes refresh {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>